import { extendTheme } from '@chakra-ui/react';

const colors = {
  brand: {
    50: '#e6f2ff',
    100: '#cce5ff',
    200: '#99c9ff',
    300: '#66adff',
    400: '#3391ff',
    500: '#0075ff',
    600: '#005ecc',
    700: '#004799',
    800: '#002f66',
    900: '#001833',
  },
  accent: {
    50: '#f2e6ff',
    100: '#e5ccff',
    200: '#cc99ff',
    300: '#b266ff',
    400: '#9933ff',
    500: '#8000ff',
    600: '#6600cc',
    700: '#4c0099',
    800: '#330066',
    900: '#190033',
  },
  dark: {
    50: '#f5f5f5',
    100: '#e6e6e6',
    200: '#cccccc',
    300: '#b3b3b3',
    400: '#999999',
    500: '#808080',
    600: '#666666',
    700: '#4d4d4d',
    800: '#333333',
    900: '#1a1a1a',
  },
};

const fonts = {
  heading: "'Poppins', sans-serif",
  body: "'Inter', sans-serif",
};

const components = {
  Button: {
    baseStyle: {
      fontWeight: '600',
      borderRadius: 'lg',
    },
    variants: {
      solid: (props) => ({
        bg: props.colorScheme === 'brand' ? 'brand.500' : `${props.colorScheme}.500`,
        color: 'white',
        _hover: {
          bg: props.colorScheme === 'brand' ? 'brand.600' : `${props.colorScheme}.600`,
        },
      }),
      outline: (props) => ({
        borderColor: props.colorScheme === 'brand' ? 'brand.500' : `${props.colorScheme}.500`,
        color: props.colorScheme === 'brand' ? 'brand.500' : `${props.colorScheme}.500`,
      }),
      ghost: (props) => ({
        color: props.colorScheme === 'brand' ? 'brand.500' : `${props.colorScheme}.500`,
      }),
    },
  },
  Card: {
    baseStyle: {
      p: '6',
      bg: 'white',
      borderRadius: 'lg',
      boxShadow: 'lg',
    },
  },
};

const styles = {
  global: {
    body: {
      bg: 'gray.50',
      color: 'dark.800',
    },
  },
};

const theme = extendTheme({
  colors,
  fonts,
  components,
  styles,
});

export default theme;
